import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./styles/PendingDraftDiscardDialog.scss";

export interface PendingDraftDiscardDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  description: string;
  confirmLabel?: string;
}

export const PendingDraftDiscardDialog: React.FC<
  PendingDraftDiscardDialogProps
> = ({
  open,
  onClose,
  onConfirm,
  title = "Удалить черновик?",
  description,
  confirmLabel = "Удалить",
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open || typeof document === "undefined") return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return createPortal(
    <div
      className="draft-discard-overlay"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="draft-discard-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="draft-discard-title"
        aria-describedby="draft-discard-desc"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="draft-discard-modal__title" id="draft-discard-title">
          {title}
        </h2>
        <p className="draft-discard-modal__text" id="draft-discard-desc">
          {description}
        </p>
        <div className="draft-discard-modal__actions">
          <button
            type="button"
            className="draft-discard-modal__btn draft-discard-modal__btn--secondary"
            onClick={onClose}
          >
            Отмена
          </button>
          <button
            type="button"
            className="draft-discard-modal__btn draft-discard-modal__btn--danger"
            onClick={handleConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
